export const DEFAULT_API_ERROR = "Something Went Wrong"